/*
    Theme is here (Light & Dark) modes

*/

const tokenKey = "darkmode";
const languageTokenKey = "language";

const getDarkmode = () => {
    return localStorage.getItem(tokenKey) || false;
};

const setDarkmode = (darkmode) => {
    if (darkmode) {
        localStorage.setItem(tokenKey, true);
        document.body.classList.add("darkmode");
        document.body.classList.add("dark");
    } else {
        localStorage.removeItem(tokenKey);
        document.body.classList.remove("darkmode");
        document.body.classList.remove("dark");
    }
};
const getLanguage = () => {
    return localStorage.getItem(languageTokenKey) || "ar"; // Default to "ar"
};

// Set language preference
const setLanguage = (language) => {
    if (language) {
        localStorage.setItem(languageTokenKey, language);
        document.documentElement.setAttribute("lang", language);
        // if (language === "ar") {
        //     document.body.setAttribute("dir", "rtl");
        // } else {
        //     document.body.setAttribute("dir", "ltr");
        // }
    }
};
const theme = {
    getDarkmode,
    setDarkmode,
    getLanguage,
    setLanguage,
};

export default theme;
